/* Registrations.js */

"use strict";
const viewRegistrations = require("@gluenetworks/wizard_view").registrations;

let Registrations = {};
Registrations.APP = "App.Wizards";
Registrations.WIZARD_SECTION = Registrations.APP + ".Section.WizardEditor";
Registrations.WIZARD_INSTANCE_EDITOR = "Editors.WizardInstanceEditor";
//VIEWS
Object.assign(Registrations, viewRegistrations);

module.exports = Registrations;
